export const SITE_URL = 'https://coinupusa.com';
export const DEFAULT_IMAGE = `${SITE_URL}/login.png`;

function upsertMeta(attr, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function upsertLink(rel, href, extra = {}) {
  let el = document.head.querySelector(`link[rel="${rel}"]${extra.hreflang ? `[hreflang="${extra.hreflang}"]` : ''}`);
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    if (extra.hreflang) el.setAttribute('hreflang', extra.hreflang);
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

function upsertJsonLd(id, data) {
  let el = document.getElementById(id);
  if (!el) {
    el = document.createElement('script');
    el.type = 'application/ld+json';
    el.id = id;
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify(data);
}

export function applySeo({ title, description, path = '/', image = DEFAULT_IMAGE, noindex = false, jsonLd }) {
  const url = path.startsWith('http') ? path : `${SITE_URL}${path}`;
  document.title = title;
  document.documentElement.lang = document.cookie.includes('lang_index=en') ? 'en' : 'zh-CN';

  upsertMeta('name', 'description', description);
  upsertMeta('name', 'robots', noindex ? 'noindex, nofollow' : 'index, follow, max-image-preview:large');
  upsertMeta('property', 'og:title', title);
  upsertMeta('property', 'og:description', description);
  upsertMeta('property', 'og:url', url);
  upsertMeta('property', 'og:image', image);
  upsertMeta('property', 'og:type', 'website');
  upsertMeta('property', 'og:site_name', 'CoinUp 理财宝');
  upsertMeta('property', 'og:locale', document.documentElement.lang === 'en' ? 'en_US' : 'zh_CN');
  upsertMeta('name', 'twitter:card', 'summary_large_image');
  upsertMeta('name', 'twitter:title', title);
  upsertMeta('name', 'twitter:description', description);
  upsertMeta('name', 'twitter:image', image);
  upsertLink('canonical', url);

  if (jsonLd) {
    upsertJsonLd('seo-jsonld', jsonLd);
  }
}

export function homeJsonLd(faqItems) {
  return {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Organization',
        '@id': `${SITE_URL}/#org`,
        name: 'CoinUp 理财宝',
        url: SITE_URL,
        logo: DEFAULT_IMAGE,
        description: 'USDT 链上锁仓生息平台，钱包签名、链上结算。',
        sameAs: []
      },
      {
        '@type': 'WebSite',
        '@id': `${SITE_URL}/#website`,
        url: SITE_URL,
        name: 'CoinUp 理财宝',
        publisher: { '@id': `${SITE_URL}/#org` },
        inLanguage: ['zh-CN', 'en']
      },
      {
        '@type': 'FAQPage',
        '@id': `${SITE_URL}/#faq`,
        mainEntity: faqItems.map((item) => ({
          '@type': 'Question',
          name: item.q,
          acceptedAnswer: { '@type': 'Answer', text: item.a }
        }))
      }
    ]
  };
}
